const ReceiptIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_766)">
        <path
          d="M10.2884 6.74639C10.2047 6.50982 10.0757 6.29468 9.91174 6.11148C9.56295 5.72179 9.05611 5.47656 8.49198 5.47656H7.01764C6.07861 5.47656 5.31738 6.23779 5.31738 7.17681C5.31738 7.97582 5.87374 8.66703 6.6543 8.83779L8.89903 9.32882C9.77347 9.52011 10.3967 10.295 10.3967 11.1901C10.3967 12.2421 9.54395 13.0956 8.49198 13.0956H7.22214C6.3928 13.0956 5.68725 12.5656 5.42577 11.8258"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.85718 5.47605V3.57129"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.85718 15V13.0952"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1429 0.714355H3.5715C2.81374 0.714355 2.08701 1.01538 1.5512 1.5512C1.01538 2.08701 0.714355 2.81374 0.714355 3.5715V19.2858L4.28578 17.1429L7.85721 19.2858L11.4286 17.1429L15.0001 19.2858V2.85721C15.0001 2.2889 15.2258 1.74384 15.6276 1.34198C16.0295 0.94012 16.5746 0.714355 17.1429 0.714355ZM17.1429 0.714355C17.7112 0.714355 18.2564 0.94012 18.6582 1.34198C19.0601 1.74384 19.2858 2.2889 19.2858 2.85721V7.85721H15.0001"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_766">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ReceiptIcon;
